import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../ui/Button';

const AnnouncementList = ({ announcements = [], showMore = false, className = '' }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('zh-CN');
  };

  const handleMoreClick = () => {
    navigate('/copyright/announcements');
  };

  // 根据当前语言获取公告标题
  const getAnnouncementTitle = (announcement) => {
    if (!announcement.i18nInfo || !Array.isArray(announcement.i18nInfo)) {
      return announcement.title || '';
    }
    
    // 获取当前语言
    const currentLocale = i18n.language;
    
    // 查找对应语言的i18nInfo
    // 首先尝试严格匹配
    let i18nItem = announcement.i18nInfo.find(item => item.locale === currentLocale);
    
    // 如果严格匹配失败，尝试使用语言代码的前两个字符进行匹配（例如 "en" 匹配 "en-US"）
    if (!i18nItem && currentLocale.length >= 2) {
      const languageCode = currentLocale.substring(0, 2);
      i18nItem = announcement.i18nInfo.find(item => item.locale.substring(0, 2) === languageCode);
    }
    
    // 如果找到对应语言的信息，返回其标题
    if (i18nItem) {
      return i18nItem.title;
    }
    
    // 如果没有找到对应语言的信息，返回默认标题或第一个i18nInfo的标题
    return announcement.title || (announcement.i18nInfo[0]?.title || '');
  };

  if (!announcements.length) {
    return (
      <div className={`bg-gray-100 rounded-lg p-4 ${className}`}>
        <div className="flex space-x-2 mb-4">
          <span className="bg-yellow-500 text-white px-3 py-1 rounded text-sm font-medium">
            {t('copyright.announcements.title', '登记公示')}
          </span>
        </div>
        <div className="text-center py-8 text-gray-500">
          {t('copyright.announcements.noData', '暂无公示信息')}
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-gray-100 rounded-lg p-4 ${className}`}>
      {/* 标题 */}
      <div className="mb-4">
        <div className="flex space-x-2 mb-4">
          <span className="bg-yellow-500 text-white px-3 py-1 rounded text-sm font-medium">
            {t('copyright.announcements.title', '登记公示')}
          </span>
        </div>

        {/* 公示列表 */}
        <ul className="space-y-2">
          {announcements.map((announcement) => (
            <li
              key={announcement.id || announcement.noticeId}
              className="text-sm text-gray-900 hover:text-blue-600 transition-colors cursor-pointer"
              onClick={() => window.open(`/copyright/announcements/${announcement.id || announcement.noticeId}`, '_blank')}
            >
              • {getAnnouncementTitle(announcement)}
            </li>
          ))}
        </ul>

        {showMore && (
          <div className="mt-4 text-right">
            <Button
              variant="text"
              size="sm"
              onClick={handleMoreClick}
              className="text-blue-600 hover:text-blue-800"
            >
              {t('common.more', '更多')} &gt;
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnnouncementList; 